import Api from '@/service/Api'

const USER_API_URL = "api/Controllers";

class SocialService 
{
  get() {
    return Api().post(`${USER_API_URL}/selectComponent.php`, {
      opcion: 1,
      datos: '*',
      table: 'social'
    })
  }
}

export default new SocialService();
